import DataService from "@/core/base/service/data.service";
import {INotificationRule} from "@/shared/model/notification-rule.model";
import axios from "axios";
import {ICampaign} from "@/shared/model/campaign.model";

export default class NotificationRuleService extends DataService<INotificationRule> {
    protected baseApiUrl: string = "api/notification-rules";

    public async testRule(entity: INotificationRule, campaign: ICampaign) {
        return axios
            .post(`${this.baseApiUrl}/${entity.id}/test?campaignId=${campaign.id}`);
    }
}
